<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <section :class="b('section')" style="--d: 80ms">
      <h3 :class="b('title')">{{ $t("Банковские реквизиты") }}</h3>

      <div :class="b('cards')">
        <SharedAdd
          v-for="requisite in bankRequisites"
          :key="requisite.id"
          :is-confirmed="true"
          :is-loading="isLoading"
          @click="handleBank(requisite)"
          @remove="handleBankRemove(requisite)"
        >
          <template #title>
            <span>{{ $t("Банковский счет") }}</span>
            <small>{{ requisite.name }}</small>
          </template>

          <template #label>{{ $t("Подтверждено") }}</template>
        </SharedAdd>

        <SharedAdd
          v-if="isBankAddShow"
          :is-loading="isLoading"
          @click="handleBank()"
        >
          <template #label>{{ $t("Добавить") }}</template>
        </SharedAdd>
      </div>
    </section>

    <section :class="b('section', { crypto: true })" style="--d: 130ms">
      <h3 :class="b('title')">{{ $t("Крипто реквизиты") }}</h3>

      <div :class="b('cards')">
        <SharedAdd
          v-for="requisite in cryptoRequisites"
          :key="requisite.id"
          :is-confirmed="true"
          :is-loading="isLoading"
          @click="handleCrypto(requisite)"
          @remove="handleCryptoRemove(requisite)"
        >
          <template #title>
            <span>{{ $t("Крипто счет") }}</span>
            <small>{{ requisite.name }}</small>
          </template>

          <template #label>{{ $t("Подтверждено") }}</template>
        </SharedAdd>

        <SharedAdd
          v-if="isCryptoAddShow"
          :is-loading="isLoading"
          @click="handleCrypto()"
        >
          <template #label>{{ $t("Добавить") }}</template>
        </SharedAdd>
      </div>
    </section>
  </div>
</template>
